module.exports = __webpack_public_path__ + "static/media/about_image.d3b2b1b8.jpg";